import { connect } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { bindActionCreators } from 'redux';

import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { SpaTreatments } from './SpaTreatments';

const mapStateToProps = (state, ownProps) => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);
  return {
    property: entitySelectors.getProperty(state),
    spaCategoryId: ownProps.categoryId,
    journeyParams,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeJourneyParam,
    },
    dispatch
  );

export const SpaTreatmentsConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaTreatments);
